import { InfluencerPayment, InfluencerTransaction } from '@hub/shared'
import TransactionDetails from '@src/components/transaction-details/transaction-details.component'
import { PropsWithChildren, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import './extract.component.scoped.scss'

interface TitleSectionProps extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  title: string
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  transactionObject: InfluencerTransaction | null | any
  hideValue: boolean
}

export default ({ transactionObject, hideValue }: Props) => {
  const [t] = useTranslation('extract')

  const deductions = useMemo(() => ['inss', 'ir', 'iss'], [])

  const TitleSection = (props: TitleSectionProps) => {
    return (
      <section>
        <div className="title">
          <h6>{props.title}</h6>
          <hr />
        </div>
        <div className="my-3">{props.children}</div>
      </section>
    )
  }

  return (
    <div className="extract">
      <section>
        <h5>{t('title')}</h5>
        <div className="my-3">
          {transactionObject?.payments?.map((payment: InfluencerPayment, index: number) => (
            <div key={index}>
              <TransactionDetails
                icon="fa-light fa-bullhorn"
                title={payment?.campaignName}
                subTitle={payment?.description}
                key={payment?.transactionId}
                value={payment?.amount}
                hideValue={hideValue}
                titleStyle={{ fontSize: '0.9rem' }}
              />
              {transactionObject?.payments.length - 1 > index ? (
                <div className="separator">
                  <div></div>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </section>
      {transactionObject?.transaction?.grossValue ? (
        <TitleSection
          title={t('totalCampaign')}
          children={
            <TransactionDetails
              icon="fa-light fa-globe"
              title={t('grossValue')}
              value={transactionObject?.transaction?.grossValue}
              hideValue={hideValue}
              titleStyle={{ fontSize: '0.9rem' }}
            />
          }
        />
      ) : null}
      {transactionObject?.transaction?.paymentType === 'rpa' ? (
        <TitleSection
          title={t('deductions')}
          children={deductions?.map((deduction, index) =>
            transactionObject?.transaction?.[`${deduction}Value`] ? (
              <div className="mb-3" key={index}>
                <TransactionDetails
                  icon="fa-light fa-file-invoice-dollar"
                  title={(deduction === 'ir' ? `${deduction}PF` : deduction).toUpperCase()}
                  aliquot={transactionObject?.transaction?.[`${deduction}Aliquot`]}
                  value={transactionObject?.transaction?.[`${deduction}Value`]}
                  hideValue={hideValue}
                  inOrOut="out"
                  titleStyle={{ fontSize: '0.9rem' }}
                />
              </div>
            ) : null
          )}
        />
      ) : null}
      {transactionObject?.transaction?.netValue ? (
        <TitleSection
          title={t('receivable')}
          children={
            <TransactionDetails
              icon="fa-light fa-money-bill-1"
              title={t('netValue')}
              value={transactionObject?.transaction?.netValue}
              hideValue={hideValue}
              inOrOut="in"
              titleStyle={{ fontSize: '0.9rem' }}
            />
          }
        />
      ) : null}
    </div>
  )
}
